/*eslint-disable*/
import { lazy } from 'react'

const NotFound = lazy(() => import(/* webpackChunkName: 'notFound' */ '@pc/modules/notFound'))
const Login = lazy(() => import(/* webpackChunkName: 'login' */ '@pc/modules/login/login'))
const ResetPassword = lazy(() => import(/* webpackChunkName: 'data-entry' */'../modules/resetPassword/resetPassword.jsx'))
const SetPassword = lazy(() => import(/* webpackChunkName: 'data-entry' */'../modules/setPassword/setPassword.jsx'))
const ForgotPassword = lazy(() => import(/* webpackChunkName: 'forgotPassword' */'../modules/forgotPassword/forgotPassword.jsx'))
const Setting = lazy(() => import(/* webpackChunkName: 'setting' */ '@pc/modules/setting'))
const Document = lazy(() => import(/* webpackChunkName: 'document' */ '@pc/modules/document'))
const LpManagement = lazy(() => import(/* webpackChunkName: 'lp-management' */ '@pc/modules/lp-management-module'))
const SetPermissions = lazy(() => import(/* webpackChunkName: 'set-permissions' */ '@pc/modules/set-permissions'))
const SetPermissionsAlert = lazy(() => import(/* webpackChunkName: 'set-permissions-aler' */ `@pc/modules/set-permissions-alert`))
const UserAgreement = lazy(() => import(/* webpackChunkName: 'userAgreement' */ `@pc/modules/userAgreement/userAgreement.jsx`))
const LpMonitor = lazy(() => import(/* webpackChunkName: 'lpMonitor' */ '@pc/modules/lpMonitor'))

/*@@@@@代码自动生成注释1 请勿删除！@@@@@*/

// Route Config
const ROUTES = [
  {
    path: "/",
    exact: true
  },
  {
    path: "/login",
    component: Login,
    auth: false, // 是否需要登录访问 default: true
  },
  {
    path: "/reset-password",
    component: ResetPassword,
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    auth: false,
  },
  {
    path: "/set-password",
    component: SetPassword,
  },
  {
    path: "/404",
    component: NotFound,
  },
  {
    path: "/setting",
    component: Setting,
  },
  {
    path: "/lp-management",
    component: LpManagement,
  },
  {
    path: "/document",
    component: Document,
  },
  {
    path: "/set-permissions",
    component: SetPermissions,
  },
  {
    path: "/set-permissions-alert",
    component: SetPermissionsAlert,
  },
  {
    path: "/user-agreement",
    component: UserAgreement,
    auth: false,
  },
  {
    path: '/lp-monitor',
    component: LpMonitor,
  },
  /*@@@@@代码自动生成注释2 请勿删除！@@@@@*/
  {
    component: NotFound,
  },
];

export default ROUTES
